module.exports = __webpack_public_path__ + "img/js.dd60b11e.svg";